import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IGNORE_ERROR_HANDLING, IS_SPINNER_ACTIVE } from '../../../util/interceptors';
import { VerificationMethod } from '../component/dto/login.dto';
import { ResendVerifySmsCodeDto } from '../component/dto/ResendVerifySmsCodeDto';
import { VerifyPhoneDto } from '../component/dto/VerifyCodeDto';
import { VerifyNewPhoneWrapper } from '../../cabinet/component/cabinet/cabinet.component';
import { UrlService } from '../../../../environments/urlService';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class PhoneService {
  private fmsUrl = '';
  private countryCodeUrl = 'https://ipapi.co/country_calling_code/';

  constructor(
    private http: HttpClient,
    private urlService: UrlService,
  ) {
    this.fmsUrl = this.urlService.getFmsUrl();
  }

  /**
   * Sets phone for new user on login process.
   * User sends phone on this endpoint, we send sms.
   *
   * @param phone user's phone
   */
  setPhone(phone: string): Promise<VerificationMethod> {
    return this.http.post<VerificationMethod>(
      this.fmsUrl + 'auth/setphone', phone,
      { withCredentials: true,
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true) },
    ).toPromise();
  }

  /**
   * Verifies sms code for user.
   *
   * @param code sms code
   */
  verifySmsCode(code: string): Promise<VerifyPhoneDto> {
    return this.http.post<VerifyPhoneDto>(
      this.fmsUrl + 'auth/verifyphone', code,
      { context: new HttpContext()
        .set(IS_SPINNER_ACTIVE, true)
        .set(IGNORE_ERROR_HANDLING, true),
      withCredentials: true,
      responseType: 'json' },
    ).toPromise();
  }


  changePhone(wrapper: VerifyNewPhoneWrapper): Promise<VerifyPhoneDto> {
    return this.http.post<VerifyPhoneDto>(
      this.fmsUrl + 'auth/verifynewphone', wrapper,
      { context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true,
        responseType: 'json' },
    ).toPromise();
  }

  changeVerificationMethod(verificationMethod: VerificationMethod): Promise<void> {
    return this.http.post<void>(
      this.fmsUrl + 'auth/change-verificationmethod', verificationMethod,
      { context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        params: { verificationMethod },
        withCredentials: true,
        responseType: 'json' },
    ).toPromise();
  }


  /**
   * Sends sms code for user. Show success notification pop up when sms was sent correctly
   */
  sendVerificationCode(phoneNumber: string, method: VerificationMethod): Promise<ResendVerifySmsCodeDto> {
    return this.http.post<ResendVerifySmsCodeDto>(
      this.fmsUrl + 'auth/sendcode', null,
      { params: { phoneNumber, method },
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true,
        responseType: 'json' },
    ).toPromise();
  }

  /**
   * Resends sms code for user. Show success notification pop up when sms was sent correctly
   */
  resendSmsCode(method: VerificationMethod): Promise<ResendVerifySmsCodeDto> {
    return this.http.post<ResendVerifySmsCodeDto>(
      this.fmsUrl + 'auth/resendcode', null,
      { params: { method },
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true,
        responseType: 'json' },
    ).toPromise();
  }

  getCountryCode(): Observable<string> {
    return this.http.get(this.countryCodeUrl,
      {
        context: new HttpContext().set(IGNORE_ERROR_HANDLING, true),
        responseType: 'text',
      });
  }
}
